export default "__VITE_ASSET__6717c54b__"